'use client'
import { useMemoizedContentGetter } from 'utils/contentful'
import { Typography } from 'components/Contentful/Typography'
import Section from 'components/Section'
import styles from './ProblemStatement.module.scss'
import { AchieveTheme } from '@achieve/ascend'
import classNames from 'classnames'
import { LinkButton } from '@/components/Contentful'
import { Image } from 'components/Image'

function ProblemStatement({ content }) {
  const {
    title,
    subtitle,
    button,
    configJson: { jsonContent } = {},
    backgroundConfig,
  } = useMemoizedContentGetter(content, [
    'title',
    'subtitle',
    'button',
    'configJson',
    'backgroundConfig',
  ]) || {}
  const {
    backgroundColor,
    titleText,
    titleColor,
    subtitleText,
    subtitleColor,
    buttonColor,
    backgroundImage,
  } = jsonContent || {}

  return (
    <Section
      className={`${styles['section']} relative z-1`}
      contain={true}
      variant={backgroundColor || null}
      backgroundColor={!jsonContent?.backgroundColor && AchieveTheme?.ascend?.colors?.blue[500]}
      fullBackground={backgroundConfig?.jsonContent?.fullBackground ?? false}
      data-testid="problem-statement-section"
    >
      {title && (
        <div className="z-10! relative!">
          <Typography
            data-testid="problem-statement-title-text"
            content={title.textContent}
            fontWeight="bold"
            component="h2"
            className={
              ('z-10! relative!',
              'leading-[130%]',
              classNames(styles['title'], titleText || 'headingLg lg:headingLg', titleColor))
            }
          />
        </div>
      )}
      {subtitle && (
        <div className="z-10! relative!">
          <Typography
            data-testid="problem-statement-subtitle-text"
            content={subtitle.textContent}
            className={classNames(
              styles['subtitle'],
              subtitleText || 'bodyLg lg:displaySm font-light! lg:font-medium!',
              subtitleColor
            )}
          />
        </div>
      )}

      {backgroundImage && (
        <Image
          className="bg-repeat bg-size-[100px_100px] z-2"
          src="/multi-site-assets/achieve-arrow-pattern-apl.svg"
          alt="Background pattern"
          layout="fill"
          preload={false}
          style={{
            objectFit: 'cover',
            width: '100%',
            height: '100%',
          }}
        />
      )}
      {button && (
        <div className={'pt-[30px] z-10'}>
          <LinkButton
            content={button}
            typographicOptions={{
              className: 'bodySm lg:bodyLg font-bold!',
              'data-testid': 'closer-statement-button-text',
            }}
            color={buttonColor ?? 'primary'}
            data-testid="closer-statment-button"
            track={{
              ...{
                click_id: button?.linkText?.json?.content?.[0]?.content[0]?.value,
                list_name: 'Product Page Closer',
                nav_link_section: 'Closer Statement',
                track_event: 'internal_campaign_click',
                click_type: 'Button Click',
                event_action: 'button_click',
                event_type: 'button_click',
              },
              ...button.event,
            }}
          />
        </div>
      )}
    </Section>
  )
}
export { ProblemStatement }
export default ProblemStatement
